import { ID, SortingMode, Task } from '@griply/types';
import {
  buildCompletedDateTree,
  CompletedDateTreeResult,
  getWeekStartsOn,
} from '@griply/utils';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

export type Options = {
  tasks: Task[];
  customOrder?: Record<ID, ID[]>;
  sortingMode?: SortingMode | null;
  fromDate?: Date;
};

export const useCompletedDateTree = ({
  tasks,
  customOrder,
  sortingMode,
  fromDate,
}: Options): CompletedDateTreeResult => {
  const today = useToday();
  const user = useUser();
  const weekStartsOn = getWeekStartsOn(user);

  return useMemo(
    () =>
      buildCompletedDateTree({
        tasks,
        customOrder,
        sortingMode,
        today,
        weekStartsOn,
        fromDate,
        rootLabel: 'Root',
      }),
    [tasks, customOrder, sortingMode, today, weekStartsOn, fromDate],
  );
};
